exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner-main[data-v-a07541c2]{padding:1.125rem}.title[data-v-a07541c2],.weight[data-v-a07541c2]{font-weight:600;color:#464646}.title[data-v-a07541c2]{font-size:20px}.item[data-v-a07541c2]{display:flex;margin-bottom:10px;margin-top:1rem}.item .left[data-v-a07541c2]{flex:1;width:15rem}.item .left .name[data-v-a07541c2]{font-weight:600;color:#464646}.item .right[data-v-a07541c2]{width:5rem;text-align:right}.item .right .rate[data-v-a07541c2]{font-weight:600;color:#464646}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a07541c2","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content/invested/Gongshang.vue
// module id = 976
// module chunks = 0